import { useEffect } from "@wordpress/element";
import { motion } from "framer-motion";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import {
	fetchSubscriptions,
	selectSubscriptions,
} from "store/vino/subscriptionsSlice";
import SubscriptionListItem from "./SubscriptionListItem";

const SubscriptionList = () => {
	const dispatch = useDispatch();
	const subscriptions = useSelector(selectSubscriptions);

	useEffect(() => {
		dispatch(fetchSubscriptions());
	}, [dispatch]);

	const container = {
		show: {
			transition: {
				staggerChildren: 0.1,
			},
		},
	};

	if (subscriptions.length === 0) {
		return (
			<div className="flex w-full justify-center text-15 mt-24">
				No subscriptions to show
			</div>
		);
	}

	return (
		<div className="flex flex-col flex-auto flex-shrink-0 w-full">
			<div className="mb-20">
				<Typography variant="h6">
					<span className="font-semibold">Subscriptions</span>
				</Typography>
			</div>
			<motion.div
				className="flex flex-wrap"
				variants={container}
				initial="hidden"
				animate="show"
			>
				<table>
					<thead>
						<tr>
							<th>Date</th>
							<th>Product</th>
							<th className="justify-end">Qty</th>
							<th>Deliver Frequency</th>
							<th>Last Delivery</th>
							<th>Next Delivery</th>
							<th>Status</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{subscriptions.map((subscription) => (
							<SubscriptionListItem
								subscription={subscription}
								key={subscription.id}
							/>
						))}
					</tbody>
				</table>
			</motion.div>
		</div>
	);
};

export default SubscriptionList;
